import { Form } from 'react-final-form'

import arrayMutators from 'final-form-arrays'
import PricingForm from './pricing/PricingForm'
import { FormattedMessage } from 'react-intl'
import filter from 'lodash/filter'
import get from 'lodash/get'
import store from 'store2'
import { parseQuery } from '../../utils'
import { useDispatch } from 'react-redux'
import { setAdventureDate } from '../../actions/adventure-actions'

export default function AdventurePricing({
  notIncludedInPrice,
  acitivityPricing,
  activityId,
}) {
  const dispatch = useDispatch()
  const { activity_date: activityDate } = parseQuery()
  const date = store('date')
  const startDate = activityDate || get(date, '[0]')

  dispatch(setAdventureDate(startDate))

  return (
    <Form
      onSubmit={() => {}}
      validate={() => {}}
      mutators={{
        ...arrayMutators,
      }}
      initialValues={{
        startDate,
        participants: {
          title: (
            <FormattedMessage id='participants' defaultMessage='Participants' />
          ),
          quantity: 0,
          ...acitivityPricing,
        },
        inclusions: filter(
          notIncludedInPrice,
          (item) => item.price_policy !== 30,
        ),
      }}
      render={({ handleSubmit, values, form }) => (
        <PricingForm
          values={values}
          handleSubmit={handleSubmit}
          activityId={activityId}
          change={form.change}
        />
      )}
    />
  )
}
